import React, { FC, CSSProperties } from 'react'
import { NumberFormatValues } from 'react-number-format'

import FormattedNumberInput from 'components/shared/FormattedNumberInput'

interface Props {
  invalid?: boolean
  value: number
  update: any
  errorMsg?: string
  id: string
  testid?: string
  style?: CSSProperties
  decimalScale?: number
  displayDelay?: number
}

// To prevent overflow, blocks entering over 99,999,999 (so 1 billion)
const MAX_VAL = 100000000
const withValueLimit = (inputObj: NumberFormatValues) => {
  if (inputObj.floatValue) {
    if (inputObj.floatValue > MAX_VAL) return false
  }
  return true
}

const CurrencyInput: FC<Props> = ({
  value,
  invalid = false,
  errorMsg = '',
  update,
  testid = '',
  id,
  style,
  decimalScale = 0,
}) => {
  return (
    <div
      className={`FormControl FormControl--withLeftIcon ${invalid && 'is-error'}`}
      style={{ maxWidth: 'initial' }}
      data-format="$"
    >
      <FormattedNumberInput
        decimalScale={decimalScale}
        id={id}
        data-testid={testid}
        value={value}
        onValueChange={values => update(values.floatValue)}
        style={style}
        isAllowed={withValueLimit}
      />
      {invalid && (
        <span
          data-testid="validationError"
          className="FormElementHelp is-error pos-absolute pt-1"
          style={{ fontSize: '12px', lineHeight: '1' }}
        >
          {errorMsg}
        </span>
      )}
    </div>
  )
}

export default CurrencyInput
